'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  width: ", ";\n"], ["\n  width: ", ";\n"])), function (_a) {
    var orientation = _a.orientation, width = _a.width;
    return "" + (width && orientation === 'vertical' ? width + "px" : '100%');
});
var Block = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  margin-bottom: ", ";\n  margin-right: ", ";\n  border-radius: 4px;\n  padding: 12px 18px 12px 18px;\n  background-color: ", ";\n"], ["\n  margin-bottom: ", ";\n  margin-right: ", ";\n  border-radius: 4px;\n  padding: 12px 18px 12px 18px;\n  background-color: ", ";\n"])), function (_a) {
    var orientation = _a.orientation;
    return "" + (orientation === 'vertical' ? '20px' : 0);
}, function (_a) {
    var orientation = _a.orientation;
    return "" + (orientation === 'vertical' ? 0 : '11px');
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.$greyLight;
});
var ContainerList = styled__default.div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: ", ";\n  height: ", ";\n  overflow: scroll;\n  cursor: pointer;\n  ::-webkit-scrollbar {\n    width: 0;\n  }\n  ::-webkit-scrollbar-thumb {\n    width: 0;\n  }\n"], ["\n  display: flex;\n  flex-direction: ", ";\n  height: ", ";\n  overflow: scroll;\n  cursor: pointer;\n  ::-webkit-scrollbar {\n    width: 0;\n  }\n  ::-webkit-scrollbar-thumb {\n    width: 0;\n  }\n"])), function (_a) {
    var orientation = _a.orientation;
    return "" + (orientation === 'vertical' ? 'column' : 'row');
}, function (_a) {
    var orientation = _a.orientation, height = _a.height;
    return "" + (height && orientation === 'vertical' ? height + "px" : 'auto');
});
var Title = styled__default.div(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  font: 700 16px/24px ", ";\n  margin-left: 9px;\n  margin-bottom: 10px;\n  color: ", ";\n"], ["\n  font: 700 16px/24px ", ";\n  margin-left: 9px;\n  margin-bottom: 10px;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

exports.Container = Container;
exports.ContainerList = ContainerList;
exports.Title = Title;
